import { SVLoader } from '@/components/core';
import TeammateForm from '@/components/teammates/forms/TeammateForm';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import { ROUTES } from '@/constants/routes';
import { useGetTeammateDetails } from '@/hooks/requests/useTeammates';
import { Card, Typography } from '@mui/material';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { useGetUser } from '@/hooks/requests/useUser';
import { UserRoles } from '@/types/user';

export default function TeammateEdit() {
  const { uuid = '' } = useParams();
  const role = useGetUser().user?.role;
  const navigate = useNavigate();
  const { teammateDetails, isTeammateDetailsPending } =
    useGetTeammateDetails(uuid);

  const isSupporter = role === UserRoles.TEAMMATE_SUPPORTER;
  if (isSupporter) {
    return <Navigate to={ROUTES.TEAMMATES} replace />;
  }

  if (isTeammateDetailsPending) {
    return (
      <DefaultLayout header="">
        <Card>
          <SVLoader />
        </Card>
      </DefaultLayout>
    );
  }

  if (!teammateDetails) {
    return (
      <DefaultLayout header="">
        <Card>
          <Typography>
            Something went wrong retrieving the teammate. Our team has been
            notified.
          </Typography>
        </Card>
      </DefaultLayout>
    );
  }

  const { user } = teammateDetails;
  const teammateName = `${user.firstName} ${user.lastName}`;

  return (
    <DefaultLayout
      header={`Edit ${teammateName}`}
      breadcrumb={[
        { label: 'Teammates', href: ROUTES.TEAMMATES },
        {
          label: teammateName,
          href: `${ROUTES.TEAMMATES}/${teammateDetails.uuid}`,
        },
        { label: 'Edit', isActive: true },
      ]}>
      <TeammateForm
        isEdit
        advisorUrl={teammateDetails.advisorUrl}
        defaultValues={{
          uuid,
          firstName: user.firstName,
          lastName: user.lastName,
          email: user.email,
          role: teammateDetails.role,
          title: user.title,
          cellPhoneNumber: user.cellPhoneNumber,
          businessPhoneNumber: user.businessPhoneNumber,
          companyId: teammateDetails.company.uuid,
          branchOfficeName: teammateDetails.branchOfficeName,
          bio: user.bio,
          members: teammateDetails?.members?.map(member => member.uuid),
          avatarUrl: user.avatar,
          avatarDisplayName: '',
          alias: teammateDetails.alias,
        }}
        onSuccess={() => navigate(`${ROUTES.TEAMMATES}/${uuid}`)}
      />
    </DefaultLayout>
  );
}
